import { render, staticRenderFns } from "./issueCard.vue?vue&type=template&id=05bcb4c5&scoped=true&"
import script from "./issueCard.vue?vue&type=script&lang=ts&"
export * from "./issueCard.vue?vue&type=script&lang=ts&"
import style0 from "./issueCard.vue?vue&type=style&index=0&id=05bcb4c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bcb4c5",
  null
  
)

export default component.exports